import { ActionReducerMap } from '@ngrx/store';

import { ICurrencyRatesFeatureStateModel } from '@features/currency-rates/models';
import { currencyRatesReducer } from './currency-rates.reducer';

export const currencyRatesFeatureReducers: ActionReducerMap<ICurrencyRatesFeatureStateModel> = {
  currencyRates: currencyRatesReducer,
};
